export var MergeExcludeItem;
(function (MergeExcludeItem) {
    MergeExcludeItem["DEFAULT_QUERY"] = "DEFAULT_QUERY";
    MergeExcludeItem["FORM_DATA"] = "FORM_DATA";
    MergeExcludeItem["CMS_STATE"] = "CMS_STATE";
    MergeExcludeItem["LOCATION_CONTEXT_OBJECT"] = "LOCATION_CONTEXT_OBJECT";
    MergeExcludeItem["LOCATION_PRODUCT_QUERY"] = "LOCATION_PRODUCT_QUERY";
    MergeExcludeItem["USER_INPUT_QUERY"] = "USER_INPUT_QUERY";
})(MergeExcludeItem || (MergeExcludeItem = {}));
